__turbopack_context__.v({
  "answer": "Pillars-module__YoBWaq__answer",
  "answerEm": "Pillars-module__YoBWaq__answerEm",
  "body": "Pillars-module__YoBWaq__body",
  "bodyDesktop": "Pillars-module__YoBWaq__bodyDesktop",
  "bodyMobile": "Pillars-module__YoBWaq__bodyMobile",
  "bubble": "Pillars-module__YoBWaq__bubble",
  "caption": "Pillars-module__YoBWaq__caption",
  "card": "Pillars-module__YoBWaq__card",
  "cardBody": "Pillars-module__YoBWaq__cardBody",
  "cardTitle": "Pillars-module__YoBWaq__cardTitle",
  "chat": "Pillars-module__YoBWaq__chat",
  "explainBody": "Pillars-module__YoBWaq__explainBody",
  "explainCopy": "Pillars-module__YoBWaq__explainCopy",
  "explainIcon": "Pillars-module__YoBWaq__explainIcon",
  "explainItem": "Pillars-module__YoBWaq__explainItem",
  "explainList": "Pillars-module__YoBWaq__explainList",
  "explainTitle": "Pillars-module__YoBWaq__explainTitle",
  "eyebrow": "Pillars-module__YoBWaq__eyebrow",
  "grid": "Pillars-module__YoBWaq__grid",
  "howItWorksLivePulse": "Pillars-module__YoBWaq__howItWorksLivePulse",
  "image": "Pillars-module__YoBWaq__image",
  "inner": "Pillars-module__YoBWaq__inner",
  "intro": "Pillars-module__YoBWaq__intro",
  "liveDot": "Pillars-module__YoBWaq__liveDot",
  "liveLabel": "Pillars-module__YoBWaq__liveLabel",
  "media": "Pillars-module__YoBWaq__media",
  "metric": "Pillars-module__YoBWaq__metric",
  "metricLabel": "Pillars-module__YoBWaq__metricLabel",
  "metricValue": "Pillars-module__YoBWaq__metricValue",
  "metrics": "Pillars-module__YoBWaq__metrics",
  "overlay": "Pillars-module__YoBWaq__overlay",
  "overlayExplains": "Pillars-module__YoBWaq__overlayExplains",
  "overlayInsights": "Pillars-module__YoBWaq__overlayInsights",
  "overlayWear": "Pillars-module__YoBWaq__overlayWear",
  "picture": "Pillars-module__YoBWaq__picture",
  "question": "Pillars-module__YoBWaq__question",
  "scrim": "Pillars-module__YoBWaq__scrim",
  "section": "Pillars-module__YoBWaq__section",
  "time": "Pillars-module__YoBWaq__time",
  "title": "Pillars-module__YoBWaq__title",
  "titleDesktop": "Pillars-module__YoBWaq__titleDesktop",
  "titleMobile": "Pillars-module__YoBWaq__titleMobile",
  "wear": "Pillars-module__YoBWaq__wear",
});
